// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useUserInputValidationError, type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';
import { useSubmitting } from '@tectonics/prs/submitting';
import { InputMask } from '@tectonics/components/input-mask';
import { LATAM_PHONE_MASK } from '@tectonics/commons/masks.js';

import { TextField } from '../../../../atoms';
import { ErrorLabel } from '../../../../molecules/error-label';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { useCurrentPaymentTypeOptionalFields } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function FieldArgentinePhoneNumber(): Node {
  const inputId = useUniqueId();
  const submitting = useSubmitting();

  const [value, handleChange] = useUserInputAsTextField('argentinePhoneNumber');

  const validationError = useUserInputValidationError('argentinePhoneNumber');
  const formHasBeenSent = useFormHasBeenSent();

  const isOptionalFieldByPaymentType = useCurrentPaymentTypeOptionalFields('telephone');

  if (isOptionalFieldByPaymentType) {
    return null;
  }

  return (
    <div data-test-name="customer-phone-number">
      <label htmlFor={inputId}>Teléfono</label>

      <TextField
        mask={LATAM_PHONE_MASK}
        as={InputMask}
        data-error={formHasBeenSent && validationError ? 'error' : null}
        fashion={formHasBeenSent && validationError ? 'error' : null}
        id={inputId}
        onChange={handleChange}
        readOnly={submitting}
        type="tel"
        value={value}
        name="customer-phone-number"
      />

      {formHasBeenSent && validationError && (
        <ValidationMessage validationError={validationError} />
      )}
    </div>
  );
}

type ValidationMessageProps = {|
  validationError: UserInputValidationError,
|};

function ValidationMessage({ validationError }: ValidationMessageProps): Node {
  switch (validationError.id) {
    case 'empty':
      return (
        <ErrorLabel>
          El número de teléfono es requerido
        </ErrorLabel>
      );

    case 'server-error':
      return (
        <ErrorLabel>
          {serverErrorMessage(validationError.payload)}
        </ErrorLabel>
      );

    default:
      return (
        <ErrorLabel>
          El número de teléfono informado es inválido
        </ErrorLabel>
      );
  }

}
